import { render, staticRenderFns } from "./unidad.vue?vue&type=template&id=5b7f5d6d"
import script from "./unidad.vue?vue&type=script&lang=js"
export * from "./unidad.vue?vue&type=script&lang=js"
import style0 from "./unidad.vue?vue&type=style&index=0&id=5b7f5d6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports